// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"844e4de5","335":"cdce38fb","415":"4d6acbeb","498":"d09a965f","511":"16f46379","513":"844123a2","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};